import {
    apiRequest,
    periodeVerifikasiList,
    periodeVerifikasiActive,
    periodeVerifikasiInactive
} from "../../../../../services/adapters/kepegawaian/periodeVerifikasiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", periodeVerifikasiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", periodeVerifikasiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", periodeVerifikasiActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository